import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import createDeepMerge from "@fastify/deepmerge";

import routingSlice from "./slices/routing";
import modalSlice from "./slices/modal";
import onboardingSlice from "./slices/onboarding";
import teamStageSlice from "./slices/team-stage";
import chatSlice from "./slices/chat";

const deepMerge = createDeepMerge({ all: true });

const useStore = create()(
  devtools(
    persist(
      (set, get) => ({
        routing: routingSlice(set, get),
        modal: modalSlice(set, get),
        onboarding: onboardingSlice(set, get),
        teamStage: teamStageSlice(set, get),
        chat: chatSlice(set, get)
      }),
      {
        name: "state-storage",
        storage: createJSONStorage(() => localStorage),
        partialize: (state) => ({
          chat: { ...state.chat, error: null }
        }),
        merge: (persisted, current) => deepMerge(current, persisted),
        onRehydrateStorage: () => {
          console.log("Starting state hydration...");
          return (_, error) => {
            if (error) {
              console.log("Error occurred during state hydration: ", error);
            } else {
              console.log("Finished state hydration...");
            }
          }
        } 
      }
    )
  )
);

if (typeof window !== undefined && window.Cypress) {
  const initialState = window.initialState;
  if (initialState) {
    useStore.setState(initialState);
  }
  window.store = useStore;
}

export default useStore;